import React, { useEffect} from "react";
import MainLayout from 'common/layouts/MainLayout'
import ContentMediaView from "shared/ContentMediaView";
import SearchField from "modules/Search/components/SearchField";
import SearchResult from "modules/Search/components/SearchResult";


const Search = ({}) => {

    useEffect(() => {
        return () => {
            //onClearSearchResult()
        }
    }, [])



    return (
        <MainLayout data-cy={'search-page'}>
            <ContentMediaView>
                <SearchField/>
                <SearchResult/>
            </ContentMediaView>
        </MainLayout>
    )
};

export default Search